import { useMediaQuery } from './use-media-query'

/** Tailwind's `lg` — the breakpoint at which the sign-in page becomes a two-column split. */
export const SPLIT_LAYOUT_QUERY = '(min-width: 1024px)'

/**
 * Whether the sign-in page is wide enough for its two-column layout.
 *
 * The featured workouts have a different home in each: the left column at `lg` and up
 * (`featured-workouts-hero-panel.tsx`), a horizontal rail under the logo below it
 * (`featured-workouts-rail.tsx`). This is a JS breakpoint rather than `hidden lg:block` on
 * both because a hidden copy is still in the DOM — `getByTestId('featured-workout-card')`
 * would match every card twice, and `.first().click()` would click an invisible one.
 */
export const useSplitLayout = (): boolean => useMediaQuery(SPLIT_LAYOUT_QUERY)
